<template>
  <div class='main-content'>
    <h2 class='main-title'>Liste des inscriptions à valider</h2>
    <table>
      <thead>
      <tr>
        <td>Nom</td>
        <td>Prénom</td>
        <td>Email</td>
        <td>Date activation lien</td>
        <td>Valider</td>
        <td>Refuser</td>
      </tr>
      </thead>
      <transition-group tag='tbody' name='fade'>
        <tr v-for='validateusers in inscriptions' :key='validateusers.id_user'>
          <td>{{ validateusers.nom }}</td>
          <td>{{ validateusers.prenom }}</td>
          <td>{{ validateusers.email }}</td>
          <td>{{ validateusers.date_activation | formatDate }}</td>
          <td class='align-center'>
            <button v-if="$can('admin') && validateusers.date_activation" class='action-icon validate-btn'
                    @click.prevent='activateUser(validateusers.id_user)'/>
          </td>
          <td class='align-center'>
            <button v-if="$can('admin') && validateusers.date_activation" class='action-icon delete-compte-btn'
                    @click.prevent='declineUsers(validateusers.id_user)'/>
          </td>
        </tr>
      </transition-group>
    </table>

    <h2 class='main-title'>Liste des utilisateurs</h2>
    <table class="validate-user">
      <thead>
      <tr>
        <th class="col-primary sortable" :class="[sortBy == 'nom' ? 'sorted' : '', sortBy == 'nom' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("nom")'>
          Nom
        </th>
        <th class="col-primary sortable" :class="[sortBy == 'prenom' ? 'sorted' : '', sortBy == 'prenom' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("prenom")'>
          Prénom
        </th>
        <th class="col-primary sortable" :class="[sortBy == 'email' ? 'sorted' : '', sortBy == 'email' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("email")'>
          Email
        </th>
        <th class="col-boolean sortable" :class="[sortBy == 'actif' ? 'sorted' : '', sortBy == 'actif' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("actif")'>
          Actif
        </th>
        <th class="col-boolean has-tooltip sortable" :class="[sortBy == 'simu_clim' ? 'sorted' : '', sortBy == 'simu_clim' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("simu_clim")'>
          <span v-tooltip="{ content : getTooltipMessage('admin_simu_clim') }">
            Accès simu.
          </span>
        </th>
        <th class="col-primary sortable" :class="[sortBy == 'role' ? 'sorted' : '', sortBy == 'role' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("role")'>
          Profil
        </th>
        <th class="col-secondary sortable" :class="[sortBy == 'date_envoi' ? 'sorted' : '', sortBy == 'date_envoi' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("date_envoi")'>
          Date ajout
        </th>
        <th class="col-secondary sortable" :class="[sortBy == 'etat' ? 'sorted' : '', sortBy == 'etat' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("etat")'>
          Statut
        </th>
        <th class="sortable" :class="[sortBy == 'motif_refus' ? 'sorted' : '', sortBy == 'motif_refus' && sortOrder == 1 ? 'asc' : 'desc']" @click='sort("motif_refus")'>
          Motif refus
        </th>
      </tr>
      </thead>
      <transition-group tag='tbody' name='fade'>
        <tr v-for='user in sortedUsers' :key='user.id_user'>
          <td>{{ user.nom }}</td>
          <td>{{ user.prenom }}</td>
          <td>{{ user.email }}</td>
          <td class="col-boolean">
            <input type="checkbox"
              v-if="!user.etat || user.etat === 'accepted'"
              :value="user.role"
              :checked="user.actif"
              @input="(e) => setActif(user.id_user, e.target.checked)"
              />
          </td>
          <td class="col-boolean">
            <input type="checkbox"
                   v-if="!user.etat || user.etat === 'accepted'"

                   :checked="user.simu_clim"
                   @input="(e) => setSimuClim(user.id_user, e.target.checked)"
            />
          </td>
          <td>
            <SelectRole :value="user.role"
              :disabled="user.etat && user.etat !== 'accepted'"
              @input="(role) => setRole(user.id_user, role)"
            />
          </td>
          <td>{{ user.date_envoi | formatDate}}</td>
          <td>{{ user.etat | formatStatus }}</td>
          <td>{{ user.motif_refus }}</td>
        </tr>
      </transition-group>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { execActivateUsers, execDeclineUsers, loadValidateUsers, updateUserRole, updateUserActif, updateUserSimuClim } from '@/api/client-api'
import SelectRole from '@/components/SelectRole'
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'Validateusers',
  mixins: [mixinTooltip],
  components: {
    SelectRole
  },

  data () {
    return {
      sortBy: 'nom',
      sortOrder: 1,
      users: [],
      inscriptions: [],
      roles: [
        { id: 'admin', nom: 'Administrateur' },
        { id: 'tech', nom: 'Technicien' },
        { id: 'exploit', nom: 'Exploitant' }
      ]
    }
  },
  created () {
    this.loadData()
  },
  filters: {
    formatDate: function (date) {
      if (!date) {
        return ''
      }
      const maDate = new Date(date)
      let month = maDate.getUTCMonth() + 1
      return 'Le ' + maDate.getDate() + '/' + month + '/' + maDate.getFullYear() + ' à ' + maDate.getHours() + 'h' + maDate.getMinutes()
    },
    formatStatus: function (status) {
      if (status === 'waiting') {
        return 'En attente'
      }
      if (status === 'declined') {
        return 'Refusé'
      }
      if (status === 'accepted') {
        return 'Accepté'
      }
    }
  },
  computed: {
    sortedUsers () {
      return [...this.users]
        .sort((a, b) => {
          let aValue = a[this.sortBy] ? a[this.sortBy] : ''
          let bValue = b[this.sortBy] ? b[this.sortBy] : ''

          if (typeof aValue === 'string' || aValue instanceof String) {
            aValue = aValue.toLowerCase()
          }
          if (typeof bValue === 'string' || bValue instanceof String) {
            bValue = bValue.toLowerCase()
          }

          if (aValue >= bValue) {
            return this.sortOrder
          }
          return -this.sortOrder
        })
    }
  },
  methods: {
    ...mapActions('prompt', ['prompt']),
    ...mapActions('confirm', ['confirm']),
    loadData () {
      loadValidateUsers()
        .then((r) => {
          this.users = r.users
          this.inscriptions = r.inscriptions
        })
    },
    declineUsers (iduser) {
      this.prompt({
        title: 'Refus inscription',
        label: 'Indiquez le motif de refus',
        okText: 'Refuser'
      })
        .then((motif) => {
          if (motif !== false) {
            execDeclineUsers(motif, iduser)
              .then((r) => {
                this.$store.dispatch('success', r)
                this.$store.dispatch('countUsers')
                this.loadData()
              })
          }
        })
    },
    activateUser (iduser) {
      this.confirm({
        title: 'Validation inscription',
        message: 'Êtes vous-sûr de vouloir valider cet utilisateur ?',
        okText: 'Valider'
      })
        .then(confirmation => {
          if (confirmation) {
            execActivateUsers(iduser)
              .then((r) => {
                this.$store.dispatch('success', r)
                this.$store.dispatch('countUsers')
                this.loadData()
              })
          }
        })
    },
    setRole (idUser, role) {
      updateUserRole(idUser, role).then(response => {
        this.users = this.users.map(user => user.id_user !== idUser ? user : { ...user, role: response })
        this.$store.dispatch('success', { message: 'Profil assigné.' })
      })
    },
    setActif (idUser, actif) {
      updateUserActif(idUser, actif).then(response => {
        this.users = this.users.map(user => user.id_user !== idUser ? user : { ...user, actif: response })
        this.$store.dispatch('success', { message: 'Utilisateur modifié.' })
      })
    },
    setSimuClim (idUser, simuClim) {
      updateUserSimuClim(idUser, simuClim).then(response => {
        this.users = this.users.map(user => user.id_user !== idUser ? user : { ...user, simu_clim: response })
        this.$store.dispatch('success', { message: 'Utilisateur modifié.' })
      })
    },
    sort (sortBy) {
      if (this.sortBy === sortBy) {
        this.sortOrder = -this.sortOrder
      } else {
        this.sortBy = sortBy
      }
    }
  }
}
</script>

<style scoped>
</style>
